export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑账号',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ status }) => !['Y'].includes(status),
  },
  {
    text: that.$l('menu_text_enabled') || '启用账号',
    icon: 'el-icon-video-play',
    menuType: 'enabled',
    divided: true,
    allow: 'E',
    disabled: ({ status }) => !['N'].includes(status),
  },
  {
    text: that.$l('menu_text_disabled') || '停用账号',
    icon: 'el-icon-video-pause',
    menuType: 'disabled',
    allow: 'S',
    disabled: ({ status }) => !['Y'].includes(status),
  },
  {
    text: that.$l('menu_text_delete') || '删除账号',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ status }) => ['D'].includes(status),
  },
]
